// src/App.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import Layout from './components/Layout';
import ErrorReports from './components/ErrorReports';
import Login from './components/Login';
import RequireAuth from './components/RequireAuth';
import LicenseManagement from './components/LicenseManagement';
import InstallerTracker from './components/InstallerTracker';
import UsageSummary from './components/UsageSummary';
import DetailedFeatureUsage from './components/DetailedFeatureUsage';
import WebsiteDownloads from './components/WebsiteDownloads';

import { API_BASE_URL } from './config';
import { getAuthHeader, isLoggedIn } from './auth';

function App() {
  const [errorReports, setErrorReports] = useState([]);

  const fetchErrors = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/errors`, { headers: getAuthHeader() });
      if (res.data?.success) {
        setErrorReports(res.data.data || []);
      } else {
        console.error('API errors:', res.data.errors);
        setErrorReports([]);
      }
    } catch (err) {
      console.error('Failed to fetch errors:', err.response?.data || err.message);
      setErrorReports([]);
    }
  };

  useEffect(() => {
    if (isLoggedIn()) {
      fetchErrors();
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public login */}
        <Route
          path="/auth/login"
          element={isLoggedIn() ? <Navigate to="/usage-summary" replace /> : <Login />}
        />

        {/* Protected area */}
        <Route element={<RequireAuth><Layout /></RequireAuth>}>
          <Route path="/" element={<Navigate to="/usage-summary" replace />} />
          <Route path="usage-summary" element={<UsageSummary />} />
          <Route path="installer-tracker" element={<InstallerTracker />} />
          <Route path="license-management" element={<LicenseManagement />} />
          <Route path="error-reports" element={<ErrorReports reports={errorReports} onRefresh={fetchErrors} />} />
          <Route path="detailed-usage" element={<DetailedFeatureUsage />} />
          <Route path="website-downloads" element={<WebsiteDownloads />} />

          {/* External redirect to Swagger */}
          <Route
            path="swagger"
            element={<Navigate to="https://api.proloadsolutions.com/swagger/index.html" replace />}
          />
        </Route>

        {/* Fallback */}
        <Route
          path="*"
          element={isLoggedIn() ? <Navigate to="/" replace /> : <Navigate to="/auth/login" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
